import {
  ADMIN_CREATE_BLOGCATEGORY_REQUEST,
  ADMIN_CREATE_BLOGCATEGORY_SUCCESS,
  ADMIN_CREATE_BLOGCATEGORY_FAIL,
  ADMIN_LIST_BLOGCATEGORY_REQUEST,
  ADMIN_LIST_BLOGCATEGORY_SUCCESS,
  ADMIN_LIST_BLOGCATEGORY_FAIL,
  ADMIN_UPDATE_BLOGCATEGORY_REQUEST,
  ADMIN_UPDATE_BLOGCATEGORY_SUCCESS,
  ADMIN_UPDATE_BLOGCATEGORY_FAIL,
  ADMIN_REMOVE_BLOGCATEGORY_REQUEST,
  ADMIN_REMOVE_BLOGCATEGORY_SUCCESS,
  ADMIN_REMOVE_BLOGCATEGORY_FAIL,
} from "./blogCategory.types";

export const blogCategoryReducer = (state = { categories: [] }, action) => {
  switch (action.type) {
    // CREATE
    case ADMIN_CREATE_BLOGCATEGORY_REQUEST:
      return { ...state, loading: true };
    case ADMIN_CREATE_BLOGCATEGORY_SUCCESS:
      return { ...state, loading: false, category: action.payload, success: true };
    case ADMIN_CREATE_BLOGCATEGORY_FAIL:
      return { ...state, loading: false, error: action.payload };

    // LIST
    case ADMIN_LIST_BLOGCATEGORY_REQUEST:
      return { ...state, loading: true };
    case ADMIN_LIST_BLOGCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload,
        // total: action.payload.totalBrandCount,
      };
    case ADMIN_LIST_BLOGCATEGORY_FAIL:
      return { ...state, loading: false, error: action.payload };

    // // UPDATE
    case ADMIN_UPDATE_BLOGCATEGORY_REQUEST:
      return { ...state, loading: true };
    case ADMIN_UPDATE_BLOGCATEGORY_SUCCESS:
      return { ...state, loading: false, category: action.payload };
    case ADMIN_UPDATE_BLOGCATEGORY_FAIL:
      return { ...state, loading: false, error: action.payload };

    // DELETE
    case ADMIN_REMOVE_BLOGCATEGORY_REQUEST:
      return { ...state, loading: true };
    case ADMIN_REMOVE_BLOGCATEGORY_SUCCESS:
      return { ...state, loading: false };

    default:
      return state;
  }
};
